import { render, staticRenderFns } from "./onlinePayStatistics.vue?vue&type=template&id=bd8a19ca&"
import script from "./onlinePayStatistics.vue?vue&type=script&lang=js&"
export * from "./onlinePayStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports